const APP_HOSTS = /(emergentagent\.com|emergent\.host|emergentcf\.cloud|localhost)$/;
export const isCustomHost = () => !APP_HOSTS.test(window.location.hostname);
